import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Menu } from 'src/app/models/common';


@Injectable({
  providedIn: 'root'
})

export class IstDataShareService {
  

  public _ApplicationID = new BehaviorSubject<string>("");
  ApplicationID = this._ApplicationID.asObservable();

  setApplicationID(value: string) {
    this._ApplicationID.next(value);
  }

  public __LeftMenu = new BehaviorSubject<Menu[]>([]);
  LeftMenu = this.__LeftMenu.asObservable();

  setLeftMenu(value :Menu[]) {
    this.__LeftMenu.next(value);
  }

  public _ISTPatientID = new BehaviorSubject<string>("");
  ISTPatientID = this._ISTPatientID.asObservable();


  setISTPatientID(value: string) {
    this._ISTPatientID.next(value);
  }


  public _OBJECTIVES=new BehaviorSubject<string>("");
  OBJECTIVES = this._OBJECTIVES.asObservable();

  setOBJECTIVES(value:string){
    this._OBJECTIVES.next(value);
  }

  public _STUDY_DESIGN = new BehaviorSubject<string>("");
  STUDY_DESIGN = this._STUDY_DESIGN.asObservable();

  setSTUDY_DESIGN(value: string) {
    this._STUDY_DESIGN.next(value);
  }

  public _HYPOTHESIS = new BehaviorSubject<string>("");
  HYPOTHESIS = this._HYPOTHESIS.asObservable();

  setHYPOTHESIS(value: string) {
    this._HYPOTHESIS.next(value);
  }

  public _BACKGROUND = new BehaviorSubject<string>("");
  BACKGROUND = this._BACKGROUND.asObservable();

  setBACKGROUND(value: string) {
    this._BACKGROUND.next(value);
  }

  public _REGULATIONS = new BehaviorSubject<string>("");
  REGULATIONS = this._REGULATIONS.asObservable();

  setREGULATIONS(value: string) {
    this._REGULATIONS.next(value);
  }

  public _TOOLS_PROCEDURES = new BehaviorSubject<string>("");
  TOOLS_PROCEDURES = this._TOOLS_PROCEDURES.asObservable();

  setTOOLS_PROCEDURES(value: string) {
    this._TOOLS_PROCEDURES.next(value);
  }

  public _PRIMARY_OUTCOMES = new BehaviorSubject<string>("");
  PRIMARY_OUTCOMES = this._PRIMARY_OUTCOMES.asObservable();

  setPRIMARY_OUTCOMES(value: string) {
    this._PRIMARY_OUTCOMES.next(value);
  }

  public _SECONDARY_OUTCOMES = new BehaviorSubject<string>("");
  SECONDARY_OUTCOMES = this._SECONDARY_OUTCOMES.asObservable();

  setSECONDARY_OUTCOMES(value: string) {
    this._SECONDARY_OUTCOMES.next(value);
  }


  public _IstMemberOrgList = new BehaviorSubject<ISTMembersOrgExt[]>([]);
  IstMemberOrgList = this._IstMemberOrgList.asObservable();

  setIstMemberOrgList(value: ISTMembersOrgExt[]) {
    this._IstMemberOrgList.next(value);
  }
}

export class ISTMembersOrgExt {
  public MemberOrganizationID: string;
  public MemberOrganizationName: string;
  public RoleID: string;
  public RoleName: string;
  public ID: string;
  public ApplicationID: string;
  public MemberID: string;
}
